// Component: FullWidthCTA
// Author: reddyb
import * as React from 'react';
import FullWidthCTANPM from '@component/FullWidthCta';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import Button from '@rotaryintl/component-button';

const FullWidthCTA = (props) => {
  const { Icon, Description, Link, LinkText } = props.fields;
  return (
    <>
      <FullWidthCTANPM
        icon={<Image field={Icon} />}
        description={<Text field={Description} />}
        link={
          <RoutableLink field={Link} useATag={true}>
            <Button variant="outline">
              <Text field={LinkText} />
            </Button>
          </RoutableLink>
        }
      />
    </>
  );
};
export default FullWidthCTA;
